// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"featuresPanel-module--wrapper--_XIie","text":"featuresPanel-module--text--33O_V","active":"featuresPanel-module--active--2PD5G"};